











































































































import {Component, Vue, Prop, Watch} from "@/common";
import {Table} from "element-ui";
import TwColumn from "./TwColumn";
import Sortable from "sortablejs";

@Component({components: {"tw-column": TwColumn}})
export default class TwTable extends Vue {
	@Prop({default: false})
	private paging!: boolean; //是否显示分页

	@Prop({default: false})
	private index!: boolean; //是否显示行号

	@Prop({default: ""})
	private height!: string; // 自定义高度

	@Prop({default: false})
	private selection!: boolean; //是否显示复选框

	@Prop({default: false})
	private expand!: boolean; //是否有展开项

	@Prop({default: false})
	private showSummary!: boolean; //是否显示合计

	@Prop({default: true})
	private highlightCurrentRow!: boolean; //是否高亮选中行

	@Prop({default: ""})
	private rowKey!: String; //数据主键

	@Prop({default: ""})
	private sumText!: String; //汇总文本

	@Prop({})
	private summaryMethod!: Function; //自定义汇总方式

	@Prop({})
	private spanMethod!: Function; //行列合并控制器

	@Prop({})
	private rowClassName!: Function | String; //设置行className

	@Prop({})
	private rowStyle!: Function | Object; //设置行style

	@Prop({})
	private cellClassName!: Function | String; //设置单元格className

	@Prop({})
	private cellStyle!: Function | Object; //设置单元格style

	@Prop({})
	private headerRowClassName!: Function | String; //设置表头className

	@Prop({})
	private headerRowStyle!: Function | Object; //设置表头style

	@Prop({})
	private headerCellClassName!: Function | String; //设置表头单元格className

	@Prop({})
	private headerCellStyle!: Function | Object; //设置表头单元格style

	@Prop({})
	private data!: Array<any>; //父组件传过来的table数据

	@Prop({default: []})
	private columns!: Array<any>; //table表头

	@Prop({})
	private action!: string; //远程加载数据

	@Prop({default: false})
	private autoLoad!: boolean; //自动加载数据

	@Prop({default: false})
	private editable: boolean; //是否允许编辑

	@Prop({default: false})
	private draggable: boolean; // 是否允许拖动

	@Prop({
		default: () => {
			return [10, 20, 30, 40, 100, 1000];
		}
	})
	private pageSizes!: Array<number>; //每页显示选择器

	@Prop({default: 20})
	private defaultSize: number;

	private pageSize: number = 20; //每页显示行数

	private currentPage: number = 1; //当前页数

	private startIndex: number = -1; //默认开始行号

	private total: number = 0; //总数据

	private pageData: Array<any> = []; //当前页数据

	private params: object = {}; //查询条件

	private loading: boolean = false; //数据加载动画

	private currentRow: object = {}; //选中行

	private selections: object = {}; //选中行

	private sortProp: string; //  排序字段

	private sortDirection: string; //  排序方向

	private sortable: any = null; // 行拖拽对象

	private select(selection, row) {
		this.$emit("select", selection, row);
	}

	private selectAll(selection) {
		this.$emit("select-all", selection);
	}

	private selectionChange(selection) {
		this.selections = selection;
		this.$emit("selection-change", selection);
	}

	private cellMouseEnter(row, column, cell, event) {
		this.$emit("cell-mouse-enter", row, column, cell, event);
	}

	private cellMouseLeave(row, column, cell, event) {
		this.$emit("cell-mouse-leave", row, column, cell, event);
	}

	private cellClick(row, column, cell, event) {
		this.$emit("cell-click", row, column, cell, event);
	}

	private cellDblclick(row, column, cell, event) {
		this.$emit("cell-dblclick", row, column, cell, event);
	}

	private rowClick(row, event, column) {
		this.currentRow = row;
		this.$emit("row-click", row, event, column);
	}

	private rowContextmenu(row, event) {
		this.$emit("row-contextmenu", row, event);
	}

	private rowDblclick(row, event) {
		this.$emit("row-dblclick", row, event);
	}

	private headerClick(column, event) {
		this.$emit("header-click", column, event);
	}

	private headerContextmenu(column, event) {
		this.$emit("header-contextmenu", column, event);
	}

	// private sortChange(param) {
	//   this.$emit("sort-change", param);
	// }

	private filterChange(filters) {
		this.$emit("filter-change", filters);
	}

	private currentChange(currentRow, oldCurrentRow) {
		this.$emit("current-change", currentRow, oldCurrentRow);
	}

	private headerDragend(newWidth, oldWidth, column, event) {
		this.$emit("header-dragend", newWidth, oldWidth, column, event);
	}

	private expandChange(row, expandedRows) {
		this.$emit("expand-change", row, expandedRows);
	}

	//根据toolslot来判断是否显示顶部工具栏
	private get showTool(): boolean {
		if (this.$slots.leftTools || this.$slots.rightTools) {
			return true;
		} else {
			return false;
		}
	}

	// 计算table高度;
	private get bodyHeight(): string {
		// if (!this.height) {
		//   return `calc(100% - ${this.diffHeight}px)`;
		// } else {
		//   return `calc(${this.height} - ${this.diffHeight}px)`;
		// }
		return "100%";
	}

	//根据tool和margin等信息统计浮动高度,作为table高度计算的一部分
	private get diffHeight() {
		let height = 0;
		height += this.showTool ? 42 : 0; //动态计算的时候 该部位的高度已经计算过了
		height += this.paging ? 35 : 0;
		return height;
	}

	//stripe会影响行样式,所以在设置行样式或者排序的情况下,取消stripe
	private get stripe() {
		if (this.rowClassName || this.rowStyle || this.draggable) {
			return false;
		}
		return true;
	}

	// 修改每页显示时候触发
	private sizeChange(val) {
		this.pageSize = val;
		this.watchData(this.data);
		this.requestData();
	}

	// 修改当前显示页时候触发
	private currentPageChange(val) {
		this.currentPage = val;
		this.watchData(this.data);
		this.requestData();
	}

	// 获取所有需要求和的属性
	private get getSummaryProps(): any[] {
		if (this.columns) {
			return this.getSummaryProp(this.columns);
		}
		return new Array<any>();
	}

	// 获取单层需要求和的属性
	private getSummaryProp(columns): any[] {
		const summary: any[] = [];
		columns.forEach(item => {
			if (!item.columns) {
				if (item.attrs && item.attrs.summary) {
					summary.push(item.prop);
				}
			} else {
				summary.push(...this.getSummaryProp(item.columns));
			}
		});

		return summary;
	}

	//自定义求和方式
	private getSummaries(param) {
		if (this.summaryMethod) {
			return this.summaryMethod(
				Object.assign(param, {summaryProps: this.getSummaryProps})
			);
		}
		const {columns, data} = param;
		const sums: any[] = [];
		columns.forEach((column, index) => {
			if (index === 1) {
				sums[index] = this.sumText || "汇总";
				return;
			}
			const summaryProp = this.getSummaryProps;
			const sumable =
				summaryProp.filter(item => item === column.property).length > 0;
			const values = data.map(item => Number(item[column.property]));
			if (!values.every(value => isNaN(value)) && sumable) {
				sums[index] = values.reduce((prev, curr) => {
					const value = Number(curr);
					if (!isNaN(value)) {
						return (prev * 100000 + curr * 100000) / 100000;
					} else {
						return prev;
					}
				}, 0);
			} else {
			}
		});

		return sums;
	}

	// 获取所有需要合并行的属性
	private get getSpanProps(): any[] {
		if (this.columns) {
			return this.getSpanProp(this.columns);
		}
		return new Array<any>();
	}

	// 获取单层需要合并行的属性
	private getSpanProp(columns): any[] {
		const span: any[] = [];
		columns.forEach(item => {
			if (!item.columns) {
				if (item.attrs && item.attrs.spanable) {
					span.push(item.prop);
				}
			} else {
				span.push(...this.getSpanProp(item.columns));
			}
		});

		return span;
	}

	private defaultSpanMethod({row, column, rowIndex, columnIndex}) {
		if (this.spanMethod) {
			return this.spanMethod({
				row,
				column,
				rowIndex,
				columnIndex,
				span: this.getSpanProps
			});
		} else {
			if (this.getSpanProps.indexOf(column.property) > -1) {
				if (
					rowIndex === 0 ||
					row[column.property] !== this.pageData[rowIndex - 1][column.property]
				) {
					const deep = this.spanDeep(
						row[column.property],
						column.property,
						rowIndex
					);
					return {
						rowspan: deep - rowIndex + 1,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		}
	}

	private defaultSort({column, prop, order}) {
		this.sortProp = prop;
		this.sortDirection = order;
		this.requestData();
	}

	private spanDeep(cellValue, prop, deep) {
		if (deep + 1 === this.pageData.length) {
			return deep;
		}
		if (this.pageData[deep + 1][prop] === cellValue) {
			return this.spanDeep(cellValue, prop, deep + 1);
		} else {
			return deep;
		}
	}

	// 给获取的数据附加上编辑标识
	private addEditStatus(data) {
		return data.map((item, index) => {
			this.$set(item, "$editable", false);
			this.$set(item, "$index", index);
			return item;
		});
	}

	//处理本地数据分页
	@Watch("data")
	private watchData(val: Array<any>) {
		if (!this.action) {
			if (this.paging) {
				this.total = val.length;
				this.startIndex = (this.currentPage - 1) * this.pageSize + 1;
				this.pageData = this.addEditStatus(
					val.slice(
						(this.currentPage - 1) * this.pageSize,
						this.currentPage * this.pageSize
					)
				);
			} else {
				this.pageData = this.addEditStatus(val);
			}
		}
	}

	//远程请求数据
	private requestData(callback?:Function) {
		this.currentRow = null;
		const _sort = this.sortProp
			? `${this.sortProp} ${
				this.sortDirection === "ascending" ? "asc" : "desc"
			}`
			: null;
		//给查询参数附带上分页信息
		const postParams = Object.assign(this.params, {
			_timestamp: new Date(),
			_start: this.currentPage - 1,
			_limit: this.paging ? this.pageSize : 99999,
			_sort
		});

		if (this.action) {
			this.loading = true;
			this.$http
				.post(this.action, postParams)
				.then(res => {
					if (res.data.status && res.data.status === 1) {
						this.$utils.Error(res.data.msg);
						return;
					}
					this.currentPage = res.data.start + 1;
					this.total = res.data.total;
					this.startIndex = (this.currentPage - 1) * this.pageSize + 1;
					this.pageData = this.addEditStatus(res.data.data);
					this.loading = false;
					if(callback){
						callback(res.data.data)
					}
				})
				.catch(err => {
					console.log(err);
					this.loading = false;
					this.$message({
						showClose: true,
						message: err,
						type: "error"
					});
				});
		}
	}

	private get table(): Table {
		return this.$refs["twtable"] as Table;
	}

	/**
	 * 清除选中数据
	 */
	public clearSelection() {
		this.table.clearSelection();
	}

	/**
	 * 切换选中状态
	 * @param index 行号
	 * @param selected 要改成的状态 缺省值 不填则反选选择
	 */
	public toggleRowSelection(index, selected?) {
		this.table.toggleRowSelection(this.pageData[index], selected);
	}

	/**
	 * 切换所有行的选中状态
	 */
	public toggleAllSelection() {
		this.table.toggleAllSelection();
	}

	/**
	 * 切换展开表格
	 * @param index 要展开的行
	 * @param expanded 要切换的状态 缺省值 不填则反向切换
	 */
	public toggleRowExpansion(index, expanded?) {
		this.table.toggleRowExpansion(this.pageData[index], expanded);
	}

	/**
	 * 指定行为选中状态
	 * @param index 要选中的行 缺省值 不填则取消已选中的当前行
	 */
	public setCurrentRow(index?) {
		const row = index > -1 ? this.pageData[index] : null;
		this.table.setCurrentRow(row);
		this.currentChange(row, this.currentRow);
		this.currentRow = row;
	}

	/**
	 * 获取当前选中行
	 */
	public getCurrentRow() {
		return this.currentRow;
	}

	/**
	 * 获取所有选中集合
	 */
	public getSelections(): Array<any> {
		const rows = this.selections as Array<any>;
		if (rows.length === undefined) {
			return [];
		}
		return rows;
	}

	/**
	 * 获取当前加载额数据
	 */
	public getData() {
		return this.pageData;
	}

	/**
	 * 获取当前加载额数据
	 */
	public fillData(data: Array<any>) {
		this.pageData.splice(0);
		this.pageData.push(...data);
	}


	/**
	 * 清除排序
	 */
	public clearSort() {
		this.sortProp = null;
		this.sortDirection = null;
		this.table.clearSort();
	}

	/**
	 * 清除过滤
	 */
	public clearFilter() {
		this.table.clearFilter();
	}

	/**
	 * 对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
	 */
	public doLayout() {
		this.table.doLayout();
	}

	/**
	 * 手动对 Table 进行排序
	 * @param prop 要排序的列
	 * @param order 排序方式
	 */
	public sort(prop, order) {
		this.table.sort(prop, order);
	}

	/**
	 * 添加新行
	 * @param data 需要初始化的数据 可空
	 * @param edit 要排序的列 添加的数据是否允许编辑(允许行编辑的情况下才有效) 可空
	 * @param index 添加位置 默认0
	 */
	public addNewRow(data?: any, edit?: boolean, index?: number) {
		data = data || {};
		data.$editable = edit || false;
		index = index || 0;
		this.pageData.splice(index, 0, data);
	}

	/**
	 * 加载数据
	 * @param params 过滤参数
	 */
	public load(params?: object,callback?:Function) {
		this.params = params || {};
		this.requestData(callback);
	}

	/**
	 * 基于上一次的查询条件重新加载数据
	 */
	public reload() {
		this.requestData();
	}

	private editData = [];

	/**
	 * 开始行编辑
	 * @param index 要编辑的当前页行号
	 * @param beforeStart 编辑判断,返回false不启动编辑 缺省值
	 */
	public startEditing(index: number, beforeStart?: () => boolean) {
		if (beforeStart) {
			if (beforeStart() === false) {
				return;
			}
		}
		if (this.pageData && index < 0 && this.editable) {
			for (let i = 0; i < this.pageData.length; i++) {
				this.editData[i] = this.pageData[i];
				this.$set(
					this.pageData,
					i,
					Object.assign({}, this.pageData[i], {$editable: true})
				);
			}
		} else {
			if (this.pageData && this.pageData[index] && this.editable) {
				this.editData[index] = this.pageData[index];
				this.$set(
					this.pageData,
					index,
					Object.assign({}, this.pageData[index], {$editable: true})
				);
			}
		}
	}

	/**
	 * 提交修改的行编辑
	 * @param index 提交编辑的当前页行号
	 * @param beforeStart 提交编辑判断,返回false无法结束编辑 缺省值
	 */
	public submitEditing(index: number, beforeEnd?: () => boolean) {
		if (beforeEnd) {
			if (beforeEnd() === false) {
				return;
			}
		}
		if (this.pageData && this.pageData[index] && this.editable) {
			this.$set(
				this.pageData,
				index,
				Object.assign({}, this.pageData[index], {$editable: false})
			);
			this.editData[index] = null;
			this.$emit("Edit", this.pageData[index]);
		}
	}

	/**
	 * 删除当前行
	 * @param index 要删除的行号
	 * @param beforeDelete 删除前判断,返回false无法删除
	 */
	public deleteRow(index: number, beforeDelete?: () => boolean) {
		if (beforeDelete) {
			if (beforeDelete() === false) {
				return;
			}
		}
		const delRows = this.pageData.splice(index, 1);
		this.$emit("Delete", delRows);
	}

	/**
	 * 取消行编辑
	 * @param index 取消编辑的当前页行号
	 */
	public cancelEditing(index: number) {
		this.$set(
			this.pageData,
			index,
			Object.assign({}, this.editData[index], {$editable: false})
		);
	}

	private mounted() {
		this.pageSize = this.defaultSize;
		if (this.autoLoad) {
			this.load();
		}

		this.setDorp(this.draggable);

		// 临时解决table中间出现emptydata层的横向滚动条问题
		this.$nextTick(() => {
			setTimeout(() => {
				this.doLayout();
			}, 300)
		});


	}

	private setDorp(val) {
		if (this.sortable) {
			this.sortable.option("disabled", !val);
		} else {
			if (val) {
				const el = (this.$refs["twtable"] as any).$el.querySelectorAll(
					".el-table__body-wrapper > table > tbody"
				)[0];
				this.sortable = Sortable.create(el, {
					ghostClass: "sortable-ghost", // Class name for the drop placeholder,
					setData: function (dataTransfer) {
						dataTransfer.setData("Text", "");
					},
					onEnd: e => {
						const targetRow = this.pageData.splice(e.oldIndex, 1)[0];
						this.pageData.splice(e.newIndex, 0, targetRow);

						const tempData = this.pageData;
						this.pageData = [];

						this.$nextTick(() => {
							this.pageData = tempData.map((data, index) => {
								data["XROWINDEX"] = index + 1;
								return data;
							});
						});

						let target;
						let type = "before";

						if (e.newIndex === 0) {
							target = tempData[1];
						} else if (e.newIndex === tempData.length - 1) {
							target = tempData[tempData.length - 2];
							type = "after";
						} else {
							target = tempData[e.newIndex + 1];
						}

						this.$emit("drop", {
							current: targetRow,
							target,
							type,
							from: e.oldIndex,
							to: e.newIndex
						});
					}
				});
			}
		}
	}

	@Watch("draggable")
	draggableChange(val) {
		this.setDorp(val);
	}
}
